<div [ngClass]="(type !== 'textarea') ? 'custom-input' : '' " class="{{wrapperClass}}" #inputEl>

  <!-- backend validation message -->
<!--  @if (getNgControlErrors()?.length) {
    <span [ngClass]="type == 'date' || type == 'time'  ? (type == 'time' ? 'form-error-icon-time' : 'form-error-icon-date') : 'form-error-icon'"
      [ngbTooltip]="getNgControlErrors()?.length ? errorTooltip : null" #t="ngbTooltip"
      triggers="manual" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" tooltipClass="apc-tooltip-top"
      placement="top"  triggers="hover">
      <img src="assets/ico/error-solid.svg" alt="error">
    </span>
  }
  <ng-template #errorTooltip>
    @for (error of $any(getNgControlErrors()); track error) {
      <span>
        {{error.message}} <br />
      </span>
    }
  </ng-template>-->

  <!-- generic input type -->
  @if (type != "textarea" && type != "date" && !isCurrency && patternKeyDown === "" ) {
    <input [autofocusCustom]="enabledFocus" #elementRef [class]="class" [type]="type"
      [placeholder]="placeholder" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" [disabled]="disabled"
      (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()" (mouseover)="onFocus(); showErrorTooltip()" (keydown)="keyDownEvent($event)"
      (focus)="onFocus()" (mouseout)="t?.close()" [readonly]="!isEdit" (keypress)="decimalWithComma($event)"/>
  }

  <!-- if input is currency -->
  @if (isCurrency) {
    <input [class]="class" [placeholder]="placeholder" [(ngModel)]="value" [disabled]="disabled"
      (ngModelChange)="onChange()" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()"
      (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" currencyMask
      [options]="{ prefix:'', suffix: ' €', thousands: '.', decimal: ',', align: 'left', nullable: 'true', inputMode: 'NATURAL' }"
      (focus)="onFocus()" [readonly]="!isEdit" />
  }

  <!-- generic date input type -->
  <div class="position-relative">
    <!-- if view mode instead of date type show text type su value can be copy pasted -->
    @if (type == "date" && !isCurrency && dateType == "text" ) {
      <input [class]="class" [value]="computedPlaceolder"
        type="text" (mouseenter)="handleDateInputEdit()" (mouseleave)="setInputTypeDate()" [readonly]="!isEdit"/>
    }
    @if (type == "date" && !isCurrency  && dateType == "date") {
      <input [class]="class"
        [placeholder]="computedPlaceolder" [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
        [disabled]="disabled" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()"
        [ngClass]="{'apc-date apc-date-placeholder': (type === 'date' && onEdit === false)}"
        (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" [type]="dateType"
        (mouseenter)="handleDateInputEdit()" (mouseleave)="setInputTypeDate()" />
    }
    <!-- input date cleaner -->
    @if (type === "date" && value) {
      <span class="ng-clear-wrapper" title="Clear all">
        <span aria-hidden="true" class="ng-clear" type="button" (click)="clearDate()">
          ×
        </span>
      </span>
    }
  </div>

  <!-- input type textarea -->
  @if (type === "textarea") {
    <textarea [class]="class" [placeholder]="placeholder" [(ngModel)]="value"
      [ngModelOptions]="{standalone: true}" [disabled]="disabled" [rows]="rows" (input)="onChange()"
      (change)="onChange()" (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" (focus)="onFocus()"  [readonly]="!isEdit">
    </textarea>
  }
</div>